import { Injectable } from "@angular/core";
import { gql, Apollo, Query } from "apollo-angular";

// Escrita à mão: o codegen aponta para um host fora do ar.
// Busca os anexos ativos da ideia (independente do card de conclusão) e se
// o usuário pode adicionar/remover (`canManageFiles`).
export type IdeaFileItem = {
  id: string;
  file?: string;
  fileName?: string;
  originalName?: string;
  createdAt?: string;
};

export type GetIdeaFilesQuery = {
  getIdea: {
    id: string;
    status: string;
    canManageFiles: boolean;
    ideafiles: IdeaFileItem[];
  };
};

export type GetIdeaFilesQueryVariables = {
  id: string;
};

export const GetIdeaFilesDocument = gql`
  query GetIdeaFiles($id: String!) {
    getIdea(id: $id) {
      id
      status
      canManageFiles
      ideafiles {
        id
        file
        fileName
        originalName
        createdAt
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class GetIdeaFilesGQL extends Query<
  GetIdeaFilesQuery,
  GetIdeaFilesQueryVariables
> {
  document = GetIdeaFilesDocument;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}
